import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Also attach bearer token if we have it (fallback path)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("hcd_token");
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Normalize non-string error.response.data.detail (Pydantic validation arrays,
// dicts, etc.) so that any downstream `toast.error(err?.response?.data?.detail)`
// call receives a safe string and never crashes React with
// "Objects are not valid as a React child".
api.interceptors.response.use(
  (r) => r,
  (error) => {
    try {
      const d = error?.response?.data?.detail;
      if (d != null && typeof d !== "string") {
        let msg;
        if (Array.isArray(d)) {
          msg = d
            .map((x) => (x && (x.msg || x.message)) || (typeof x === "string" ? x : JSON.stringify(x)))
            .join(", ");
        } else if (typeof d === "object") {
          msg = d.msg || d.message || JSON.stringify(d);
        } else {
          msg = String(d);
        }
        error.response.data.detail = msg;
      }
    } catch (_) {
      // best-effort — never let interceptor itself throw
    }
    return Promise.reject(error);
  }
);

export default api;
